import { useAuth } from "../context/AuthContext";

export const SensitiveArea = ({ children }) => {
  const { user } = useAuth();
  if (user?.role === "admin") return children;
  return (
    <div
      data-testid="sensitive-area"
      className="select-none"
      onContextMenu={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
    >
      {children}
    </div>
  );
};
